import { useForm } from 'react-hook-form';
import { styled } from '@mui/material';
import { forwardRef, useEffect, useImperativeHandle } from 'react';
import TextInput from '../../forms/TextInput';
import { AdminSettingFormRef } from './AdminSettingsDialog';
import { useCommonTranslation } from '../../../hooks/useCommonTranslation';
import { AdminSettingId } from './AdminSettings';

const StyledTextInput = styled(TextInput)(({ theme }) => ({
  width: 165,
}));

interface SingleNumberInputFieldFormProps {
  settingId: AdminSettingId;
  value?: number;
}

export const SingleNumberInputFieldForm = forwardRef<
  AdminSettingFormRef,
  SingleNumberInputFieldFormProps
>(({ value, settingId }, ref) => {
  const t = useCommonTranslation();
  const {
    control,
    setValue,
    getValues,
    trigger,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    defaultValues: { [settingId]: '' },
  });
  const requiredFieldMessage = t('common.requiredField');

  useImperativeHandle(ref, () => ({
    getValues,
    triggerValidation: () => trigger(),
    isValid,
  }));

  useEffect(() => {
    if (value != null) {
      setValue(settingId, `${value}`);
    }
  }, [value]);

  return (
    <StyledTextInput
      name={settingId}
      label={t(`adminSettings.${settingId}InputLabel`)}
      type="number"
      inputProps={{
        min: 0,
        step: 1,
      }}
      control={control}
      required
      errors={errors}
      rules={{
        required: requiredFieldMessage,
        min: {
          value: 0,
          message: t('adminSettings.rangeError'),
        },
      }}
    />
  );
});
